<app-menu></app-menu>
<mat-toolbar color="primary"> Refresh caches </mat-toolbar>
<mat-card>
  <mat-grid-list cols="5" rowHeight="50px">
    <mat-grid-tile colspan="2"></mat-grid-tile>
    <mat-grid-tile colspan="1">
      <button class="embargo" mat-raised-button (click)="refreshCaches(testArea.EMBARGO)">
      Refresh caches for Embargo
    </button></mat-grid-tile>
    <mat-grid-tile colspan="2"></mat-grid-tile>
    <mat-grid-tile colspan="2"></mat-grid-tile>
    <mat-grid-tile colspan="1">
      <button class="pre-prod" mat-raised-button (click)="refreshCaches(testArea.PREPROD)">
      Refresh caches for Preprod
    </button></mat-grid-tile>
    <mat-grid-tile colspan="2"></mat-grid-tile>
    <mat-grid-tile colspan="2"></mat-grid-tile>
    <mat-grid-tile colspan="1">
      <button class="prod" mat-raised-button (click)="refreshCaches(testArea.PROD)">
      Refresh caches for Prod
    </button></mat-grid-tile>
    <mat-grid-tile colspan="2"></mat-grid-tile>
  </mat-grid-list>
</mat-card>


